'use client';

import Anchor from 'components/typography/anchor';
import { useSession } from 'next-auth/react';
import PropTypes from 'prop-types';
import config from 'siteconfig';

const StripeError = ({ error, sentryEventId }) => {
  const { data: session } = useSession();
  const user = session?.user;
  let message = error.message;

  if (error.type === 'card_error') {
    message += ` (Decline code: ${error.decline_code})`;
  }

  return (
    <div className="card-flat border-red-500 p-16">
      <h3>There was a problem with your payment!</h3>
      <p className="rounded-sm border bg-stone-200 p-1 font-mono dark:bg-stone-700">
        <code>{message}</code>
      </p>
      <p>
        Please{' '}
        <Anchor
          className="anchor-text"
          href={`mailto:${config.emailAddresses.support}?subject=Payment%20Issue&body=%0A%0A---%0ADiagnostics:%0AEvent ID:%20${sentryEventId}%0ACustomer%20ID:%20${user?.stripe?.customerId}%0AUser%20ID:%20${user?.id}`}
        >
          email us
        </Anchor>{' '}
        and our volunteers will help! If you can fix this yourself,{' '}
        <Anchor
          href="/"
          className="anchor-text"
          onClick={() => {
            location.reload();
          }}
        >
          reload this page
        </Anchor>{' '}
        and try again.
      </p>
    </div>
  );
};

StripeError.propTypes = {
  error: PropTypes.shape({
    charge: PropTypes.string,
    code: PropTypes.string,
    decline_code: PropTypes.string,
    doc_url: PropTypes.string,
    message: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
};

export default StripeError;
